import type { ParentComponent } from "solid-js";
import "./ListTitle.css";
import { Text } from "./typography/Text";

type Props = {
	theme?: "default" | "dark";
};
export const ListTitle: ParentComponent<Props> = (props) => {
	return (
		<Text
			as="h2"
			family="mono"
			size="small"
			weight="bold"
			color="fg3"
			transform="uppercase"
			class="gvtui-list-title"
			classList={{ "gvtui-list-title-dark": props.theme === "dark" }}
		>
			{props.children}
		</Text>
	);
};
